import React from 'react';
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText
} from "@material-ui/core";
import tools from '../../../../../../../../services/tools';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import { Controller } from 'react-hook-form';


function IntegrationForm(props){
  const { isEditableForm } = props;
  const { domain, client_id, client_secret, integration_backend, redirect_uri } = props.data || {};  
  const { register, errors, control, watch } = props.formConfig; 
  const watchIntegrationType = watch("integration_backend", integration_backend || "CANVAS") ; 
  const isGoogleClassroom = watchIntegrationType === "GOOGLE_CLASSROOM";


  const REDIRECT_URI = redirect_uri || `${tools.getBaseHost()}/integrations/canvas/oauth2response/`;
  const rows = [
    { 
      "Key Name": 'FLO-OPS',
      "Redirect URIs": REDIRECT_URI,
      "Icon URL": 'https://flo-assets-stage-bucket.s3.amazonaws.com/logob.svg'
    },
  ];

  return (
    <form noValidate autoComplete="off" >      
        <Grid container spacing={3} direction="row">

        {isEditableForm &&  watchIntegrationType === "CANVAS" && (
          <Grid item xs={12}>
            <p>Before continue, please Add this information on your Canvas settings &gt; Developer Keys:</p>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableBody>                      
                      {Object.entries(rows[0]).map(([key, value]) => (
                        <TableRow key={key}>
                          <TableCell component="th" scope="row">
                            {key}
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {value}
                          </TableCell>
                        </TableRow>          
                      ))}            
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        )}
        
        <Grid item xs={12}>          
            <FormControl 
              variant="filled" 
              fullWidth={true}
              error={errors.integration_backend ? true : false}
              disabled={!isEditableForm}
              >
              <InputLabel id="integration_backend-label">Integration type</InputLabel>
              <Controller
                as={
                  <Select labelId="integration_backend-label">
                    <MenuItem value={'CANVAS'}>Canvas</MenuItem>
                    <MenuItem value={'GOOGLE_CLASSROOM'}>Google Classroom</MenuItem>
                  </Select>
                }
                name="integration_backend"
                rules={{ required: "this is required" }}
                control={control}
                defaultValue={integration_backend || props.integration_backend || 'CANVAS'}
              />
              <FormHelperText>{errors.integration_backend ? errors.integration_backend.message : null}</FormHelperText>
              
            </FormControl>
          </Grid>

          {!isGoogleClassroom && (       
            <React.Fragment>       
            <Grid item xs={12}>
              <TextField 
                id="filled-basic"
                label="Domain"
                name="domain"
                placeholder="Ex: flo.integrations.com"
                variant="filled"
                disabled={!isEditableForm}
                fullWidth={true}

                defaultValue={domain}
                inputRef={register({ required: true, minLength: { value: 3, message: "Too short!." } })}
                error={errors.domain ? true : false}
                helperText={errors.domain ? errors.domain.message : null}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField 
                id="filled-basic"
                label="Client ID"
                name="client_id"
                placeholder="Ex: 1100...."
                variant="filled"
                disabled={!isEditableForm}
                fullWidth={true}

                defaultValue={client_id}
                inputRef={register({ required: true, minLength: { value: 3, message: "Too short!." } })}
                error={errors.client_id ? true : false}
                helperText={errors.client_id ? errors.client_id.message : null}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField 
                id="filled-basic"
                label="Client Secret"
                name="client_secret"
                placeholder="Client Secret"
                variant="filled"
                disabled={!isEditableForm}
                fullWidth={true}
                type="password"

                defaultValue={client_secret}
                inputRef={register({ required: true, minLength: { value: 3, message: "Too short!." } })}
                error={errors.client_secret ? true : false}
                helperText={errors.client_secret ? errors.client_secret.message : null}
              />
            </Grid>
            </React.Fragment>
          )}
        
          {/* Show Form action buttons only when Edit action is active */}
          {props.children}
        </Grid>
    </form>
  )
}

export default IntegrationForm;